import LyriaPay from './components/LyriaPay';

export default LyriaPay;
